const DATE_PATTERN = /(?<day>0[1-9]|1\d|2\d|3[01])\/(?<month>0[1-9]|1[0-2])\/(?<year>\d{4})/;
const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
    return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

function validateDate(year, month, day) {
    if (month < 1 || month > 12 || day < 1) {
        return false;
    }

    const monthIndex = month - 1;
    const isLeapYear = isLeapYearIndex(year);

    if (isLeapYear && day > DAYS_IN_MONTH_LEAP_YEAR[monthIndex]) {
        return false;
    }

    if (!isLeapYear && day > DAYS_IN_MONTH[monthIndex]) {
        return false;
    }

    return true;
}

export default function isValidDate(value) {
    const dateRegExp = new RegExp(DATE_PATTERN);
    const match = dateRegExp.exec(value);

    if (!match || !match.groups) {
        return false;
    }

    const { year, month, day } = match.groups;

    return validateDate(year, month, day);
}
